<template>
  <div>
    <div class="barrage" ref="wrapper">
        <div id="barrage_wrap" class="barrage_wrap">
          <div class="bar_block" v-for="(item, index) in barrageList" :key="index+'bar'">
            <div class="barragediv entry" v-if="item.isEntry">
              Welcome<span>{{item.name}}</span>into the hall
            </div>
            <div class="barragediv " v-else>
              <span class="barrage_name">{{item.name}}：</span>
              {{item.text}}
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Bscroll from "better-scroll";
export default {
  name: "live-contact",
  data() {
    return {
      scroll: null,
      isBottom: true,
      isTouch: false,
      isrefresh: false,
      stortBarrageList: [], //超过100条储存数组
      newBarrageList: [],
      barrageList: [] //接受留言列表
    };
  },
  computed: {
    ...mapGetters({
      // roomid: "getRoomid",    //房间号
    }),
    query() {
      return this.$router.history.current.query;
    },
    roomid(){
      return this.query.actId;
    },
  },
  mounted() {
    this.getTopBarrage();
    this.initSwiper();
  },
  methods: {
    ...mapActions({
      getBarrage:'live/getBarrage'
    }),
    //获取前20条留言
    async getTopBarrage(){
      let res=await this.getBarrage(this.roomid);
      if(res){
        let arr=[];
        res.forEach(el => {
          if(el.isShow&&el.userInfo){
            arr.push({
              id:el.id,
              isEntry:false,
              name:JSON.parse(el.userInfo).nickName||JSON.parse(el.userInfo).name,
              text:el.content
            })
          }
        });
        this.barrageList=[...this.barrageList,...arr.reverse()];
        if(this.barrageList.length>4){
          this.$nextTick(()=>{
            this.isBottom=false;
          })
        }
        
      }
    },
    initSwiper() {
      this.scroll = new Bscroll(this.$refs.wrapper, {
        scrollY: true,
        click: true,
        probeType: 3,
        mouseWheel: true,
        bounce: {
          top: true,
          bottom: true
        },
        scrollbar: {
          fade: true
        }
      });
      let that = this;
      //用户轻抚
      this.scroll.on("flick", () => {
        let barAllH = $(".barrage_wrap").height();
        let wrapH = $(".barrage ").height();
        if (barAllH > wrapH) {
          that.isTouch = true;
        }
      });
      //滚动中
      this.scroll.on("scroll", obj => {
        // if($('.barrage .bscroll-vertical-scrollbar .bscroll-indicator')){
        //    $('.barrage .bscroll-vertical-scrollbar .bscroll-indicator').addClass('scrollstyle');//
        // }
        let barAllH = $(".barrage_wrap").height();
        // console.log(barAllH,'滚动中haodu')
        if (barAllH - 164 <= Math.abs(obj.y) + 20) {
          that.isBottom = true;
          that.isTouch = false;
          if (that.newBarrageList.length) {
            that.getNewBarrage();
            // that.dataPush(model);
            // }
          }
        } else if (barAllH - 164 > 0) {
          that.isBottom = false;
        }
      });
    },
    //下拉刷新被触发
    dropRefresh(e) {
      setTimeout(() => {
        this.isrefresh = true;
        console.log();
      }, 3000);
      console.log(this.isrefresh, "下拉刷新");
    },
    //设置滚动条滚动至底
    setScrollTop() {
      let Lis = $(".bar_block"); // 查找所有bar_block元素
      this.scroll.refresh();
      this.scroll.scrollToElement(Lis[Lis.length - 1], 300); // 滑动到指定元素,设置动画300ms
    },
    //数据获取
    dataPush(data) {
       if (true) {   //this.isBottom && !this.isTouch
        // if(this.barrageList.length>20){    dom多了处理
        //    this.stortBarrageList.push(this.barrageList.shift());
        // }
        this.barrageList.push(data);
        this.$nextTick(() => {
          this.setScrollTop();
        });
      } else {
        // this.newBarrageList.push(data);
        this.$set(this.newBarrageList, this.newBarrageList.length, data);
      }
      //
    },
    //读取新消息
    getNewBarrage() {
      this.barrageList = [...this.barrageList, ...this.newBarrageList];
      this.newBarrageList = [];
      this.isBottom = true;
      this.$nextTick(() => {
        this.setScrollTop();
      });
    },
    //删除留言
    delBarrage(barId){
      if(this.newBarrageList.length>0){
        let ind=this.newBarrageList.findIndex(mode => (mode.id === barId));
        if(ind!=-1){
          this.newBarrageList.splice(index,1);
        }
      }
      if(this.barrageList.length>1){
        let index=this.barrageList.findIndex(item => (item.id!='1'&&item.id === barId));
        if(index>0){
          this.barrageList.splice(index,1);
        }
      }
    },
    //观众进入判断
    viewerEntry(data){
      let arr=[...this.barrageList,...this.newBarrageList];
      let found=arr.some(el=>el.id===data.id&&data.isEntry);
      if(!found){
        this.dataPush(data);
      }
    },
  }

};
</script>

<style lang="scss" scoped>
.lc {
  padding: 20px 15px 60px;
  position: relative;
  height: 100%; 
  .line {
    font-size: 13px;
    margin-bottom: 5px;
    color: #333;
    display: block;
    max-width: 5.6rem;
    .info{
      display: inline-block;
      padding: 5px 8px 5px 5px;
      background-color: #f2f2f2;
      border-radius: 5px;
    }
    &:last-child {
      margin-bottom: 60px;
    }
    .txt1 {
      color: #ffbb7e;
    }
  }
}
</style>
<style scoped lang="scss">
.barrage {
  height: calc(100vh - 440px);
  z-index: 9;
  position: absolute;
  top: 20px;
  right: 15px;
  left: 15px;
  bottom:60px;
   width: 6rem;
  // font-size: 0.24rem;
  // height: 2.8rem;
  // z-index: 99;
  // left: 3.3rem;
  // position: absolute;
  // bottom:0;
  transition: all 0.3s;
  overflow-y: auto;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  &::-webkit-scrollbar {
    width: 0 !important;
  }
}
.barrage .scrollstyle {
  width: 50% !important;
  left: 50% !important;
  margin-left: -25% !important;
}

.barrage .bar_block {
  padding-bottom: 0.1rem;
  max-width: 5rem;
  &:last-child {
    padding-bottom: 0;
  }
}
.barrage_wrap {
  // padding-bottom: 0.1rem;
  position: absolute;
}
.barrage .barragediv {
  word-wrap: break-word; /*在长单词或URL地址内部进行换行，防止过长导致自动换行 */
  word-break: break-all; /*允许再单词内换行*/
  display: inline-block;
  max-width: 5rem;
  color: #333;
  background-color: #f2f2f2;
  border-radius: 3px;
  line-height: 0.46rem;
  padding: 0 0.1rem;
  text-align: justify;
  vertical-align: top;
  &.hint{
    color: #ffbb7e;
    line-height:0.32rem;
    padding: 0.1rem;
  }
  &.entry{
    color: #ffbb7e;
    span{
      color: #333;
      margin: 0 0.1rem;
    }
  }
}
.barrage .barragediv .barrage_name {
  color: #ffbb7e;
}
.fullwrap {
  position: absolute;
  right: 0;
  left: 0;
  bottom: 2.02rem;
  height:2.8rem;
  z-index: 90;
}
.newBarrage {
  display: inline-block;
  color: #f85b0f;
  position: absolute;
  font-size: 0.24rem;
  padding: 0 0.19rem;
  border-radius: 3px;
  bottom: 0;
  height: 0.56rem;
  z-index: 99;
  line-height: 0.56rem;
  background: #fff;
  left: 0.3rem;
  letter-spacing: 1px;
}
</style>